import { AxiosResponse } from "axios";
import { BaseFormPackageProcessorInstanceModel, FormPackageProcessorInstance } from "../../DTOtemp";
import SecureClient from "../SecureClient";

export class FormPackageProcessorInstancesClient extends SecureClient {
	private _packageId: number

	private _urlBase: string

	constructor(
		packageId: number,
	) {
		super()
		this._packageId = packageId
		this._urlBase = `FormPackages/${this._packageId}/ProcessorInstances`
	}

	public getFormPackageProcessorInstance(instanceId: number): Promise<AxiosResponse<FormPackageProcessorInstance>> {
		return this._api.get<FormPackageProcessorInstance>(`${this._urlBase}/${instanceId}`, {
			headers: {
				...this.authorizationHeader,
				...this.acceptHeader(),
			},
		})
	}

	public createFormPackageProcessorInstance(processorInstance: BaseFormPackageProcessorInstanceModel): Promise<AxiosResponse<FormPackageProcessorInstance>> {
		return this._api.post<FormPackageProcessorInstance>(`${this._urlBase}`, processorInstance, {
			headers: {
				...this.authorizationHeader,
				...this.acceptHeader()
			}
		})
	}

	public updateProcessorInstance(id: number, updatedInstance: BaseFormPackageProcessorInstanceModel): Promise<AxiosResponse<FormPackageProcessorInstance>> {
		return this._api.put<FormPackageProcessorInstance>(`${this._urlBase}/${id}`, updatedInstance, {
			headers: {
				...this.authorizationHeader,
				...this.acceptHeader()
			}
		})
	}

	public deleteProcessorInstance(id: number): Promise<AxiosResponse> {
		return this._api.delete(`${this._urlBase}/${id}`, {
			headers: {
				...this.authorizationHeader,
				...this.acceptHeader()
			}
		})
	}

}